import React from 'react';
import { useTranslation } from 'react-i18next';
import languageIcon from  '../../assets/images/LanguageIconGreen.svg';
import '../../stylesheets/mobile-language-selector.scss';


type MobileLanguageSelectorProps = {
  triggerLanguagePicker: () => void;
  className: string;
}

export const MobileLanguageSelector: React.FC<MobileLanguageSelectorProps> = ({triggerLanguagePicker, className}) =>
{
  const { i18n } = useTranslation();

  return (
    <div className={`language-select-grp ${className}`}>
      <button className="language-button" onClick={triggerLanguagePicker} key={i18n.language}>
        <img src={languageIcon} alt="Language Icon" className="language-icon"/>
        <span className='language-text'>
          {i18n.language === 'zh_HK' ? '繁體中文' : i18n.language === 'sc_CN' ? '简体中文' : 'English'}
        </span>
      </button>
    </div>
  );
};





